import { render, staticRenderFns } from "./ItineraryList.vue?vue&type=template&id=bb2b8dee&"
import script from "./ItineraryList.vue?vue&type=script&lang=js&"
export * from "./ItineraryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports